export default __webpack_public_path__ + "static/media/check-marker.0473b526.svg";